<app-page-header [breadcrumbs]="breadcrumbs" />
<div
  class="mx-auto rounded-lg bg-white md:max-w-5xl lg:max-w-7xl xl:max-w-[1400px] 2xl:max-w-[1800px]"
>
  <app-trip-header
    ><p-button
      [label]="
        (factorUpdatedAfterTrip
          ? 'calculator.calculateAndContribute'
          : 'calculator.calculate'
        ) | transloco
      "
      icon="pi pi-chart-line"
      [loading]="isCalculating()"
      [disabled]="!canCalculate()"
      (onClick)="calculateImpact()"
  /></app-trip-header>
  <app-prestation-section />
  <section class="flex flex-col gap-4 px-4 py-6 md:px-12">
    <h2 class="text-primary-900">{{ "calculator.globalInfo" | transloco }}</h2>
    <div class="flex flex-col gap-6 sm:flex-row">
      <div class="flex-1"><app-meal-section /></div>
      <div class="flex-1"><app-waste-section /></div>
    </div>
  </section>

  <!-- Validation Loading State -->
  @if (tripService.isValidating()) {
    <div class="mx-12 mb-4 flex items-center gap-2 rounded-lg bg-blue-50 p-3">
      <i class="pi pi-spin pi-spinner text-blue-600"></i>
      <span class="text-sm text-blue-800">{{
        "validation.validating" | transloco
      }}</span>
    </div>
  }

  <!-- Calculate Impact CTA Section -->
  <section class="flex flex-col items-end gap-3 px-12 pb-8">
    <app-trip-validation-badge
      tooltipPosition="top"
      [clickAction]="scrollToFirstInvalidItem"
    />
    <p-button
      [label]="'calculator.calculateAndContribute' | transloco"
      icon="pi pi-chart-line"
      [loading]="isCalculating()"
      [disabled]="!canCalculate()"
      (onClick)="calculateImpact()"
    />
  </section>
</div>
<app-trip-creation-modal />
<p-dialog
  [header]="'tripDashboard.warning' | transloco"
  [(visible)]="displayWarningDialog"
  [modal]="true"
  [closable]="false"
>
  <div class="max-w-[500px] text-paragraph-med text-greyscale-700">
    {{ "tripDashboard.warningText" | transloco }}
  </div>
  <div class="flex-raw flex justify-end">
    <p-button label="ok" (onClick)="displayWarningDialog = false" />
  </div>
</p-dialog>
